export enum StoreWorkstationType {
  VIRTUAL = "VIRTUAL",
  MANNED = "MANNED",
}
